import { render, staticRenderFns } from "./QueueStatus.vue?vue&type=template&id=0440dc32&"
import script from "./QueueStatus.vue?vue&type=script&lang=js&"
export * from "./QueueStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports